var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 15,
    width: 20,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "rotate(-90.33919525146484 8.99551773071289,6.333353996276855) ",
    id: "svg_1",
    fill: "#B6BEC2",
    d: "m5.681135,5.828375l5.13346,-5.781474c0.24749,-0.278758 0.64898,-0.278758 0.89647,0l0.5988,0.674416c0.24723,0.278449 0.24749,0.729448 0.00105,1.008497l-4.06846,4.603404l4.0682,4.603684c0.2467,0.279108 0.24617,0.730098 -0.00106,1.008506l-0.59879,0.674436c-0.2475,0.278708 -0.64898,0.278708 -0.89647,0l-5.1332,-5.781784c-0.24749,-0.278748 -0.24749,-0.730937 0,-1.009686z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBottom);
export default __webpack_public_path__ + "static/media/chevron-bottom.8b13105e076b565c9098005270642f08.svg";
export { ForwardRef as ReactComponent };